module.exports = __webpack_public_path__ + "img/small-3.e88f2929.webp";